import { apiService } from './api';
import { OutletDTO, OutletListDTO, CreateOutletDTO } from '../types';

const API = '/outlets';

export const outletService = {
  getAll: (pageNumber = 1, pageSize = 100) =>
    apiService.get<{ data: OutletListDTO[] }>(API, { pageNumber, pageSize }),

  getById: (id: number) =>
    apiService.get<OutletDTO>(`${API}/${id}`),

  create: (data: CreateOutletDTO) =>
    apiService.post<OutletDTO>(API, data),

  update: (id: number, data: Partial<CreateOutletDTO>) =>
    apiService.put<OutletDTO>(`${API}/${id}`, data),

  delete: (id: number) =>
    apiService.delete<boolean>(`${API}/${id}`),
};
